import {Component, OnInit, ViewChild, HostListener} from '@angular/core';
import {HelperService} from '../helper.service';
import {Subject} from 'rxjs/Subject';
import {Http, Response, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {DataTableDirective} from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Data {
  id: number = 0;
  name: string = '';

}

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.css'],
  providers: [HelperService]
})
export class CouponsComponent implements OnInit {
// 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  list = true;
  edit = false;
  add = false;
  view = false;
  icon = this.helper.add_icon;
  icon_action = 'addClick';
  searchResult = [];
  couponData = [];
  datas: any = [];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dtElement: DataTableDirective;

  title: any;
  coupon_code;
  toc;
  description;
  expiry_date;
  enddate;
  percentage;
  count;
  status = '';
  update_title;
  update_coupon_code;
  update_used_count;
  update_toc = '';
  update_description = '';
  update_expiry_date;
  update_enddate;
  update_percentage;
  update_count;
  update_status = '';
  update_created_at = '';
  coupon_id;
  created_user;
  todayDate: Date = new Date();
  user = this.cookie.get('user_id');
  user_permissions: any = [];
  user_token = localStorage.getItem('access_token');
  private headers: Headers = new Headers({
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + this.user_token
  });

  constructor(private helper: HelperService, private http: Http, private snackbar: MatSnackBar, private activatedRouter: ActivatedRoute, private router: Router, private cookie: CookieService) {
    activatedRouter.queryParams.subscribe(params => {
      if (params['id']) {
        let id = params['id'];
        this.viewClick(id);
      }
    });
  }


  ngOnInit() {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      order: []
    };

    this.http.get(this.helper.base_url + 'http/get/coupons', {headers: this.headers})

      .subscribe(data => {
        this.datas = JSON.parse(data['_body']);
        this.dtTrigger.next();


      });

    let user = this.cookie.get('user_id');
    this.http.get(this.helper.base_url + '/http/get/user/permissions', {headers: this.headers})

      .subscribe(data => {
        this.user_permissions = JSON.parse(data['_body']);
        //console.log(this.user_permissions);


      });
  }

  addClick(e) {
    this.list = false;
    this.edit = false;
    this.add = true;
    this.view = false;
    this.icon = this.helper.list_icon;

    this.icon_action = 'listClick';
  }

  listClick(e) {
    this.list = true;
    this.edit = false;
    this.add = false;
    this.view = false;
    this.icon = this.helper.add_icon;
    this.icon_action = 'addClick';
  }

  viewClick(id) {
    this.http.get(this.helper.base_url + 'http/get/coupon/' + id, {headers: this.headers})
      .subscribe(data => {
        //console.log(JSON.parse(data['_body']).coupon_createdby.name);
        this.couponData = JSON.parse(data['_body']);
        this.update_expiry_date = new Date(JSON.parse(data['_body']).expiry_date);
        this.update_status = JSON.parse(data['_body']).status;
        this.update_count = JSON.parse(data['_body']).count;
        this.update_used_count = JSON.parse(data['_body']).order_status.length;
        this.update_description = JSON.parse(data['_body']).description;
        this.update_toc = JSON.parse(data['_body']).toc;
        this.coupon_id = JSON.parse(data['_body']).id;
        this.update_created_at = JSON.parse(data['_body']).created_date;
        this.created_user = JSON.parse(data['_body']).coupon_createdby.name;
      });

    this.list = false;
    this.edit = false;
    this.add = false;
    this.view = true;
    this.icon = this.helper.list_icon;
    this.icon_action = 'listClick';
  }

  editClick(id) {
    this.http.get(this.helper.base_url + 'http/get/coupon/' + id, {headers: this.headers})
      .subscribe(data => {

        this.couponData = JSON.parse(data['_body']);
        this.update_expiry_date = new Date(JSON.parse(data['_body']).expiry_date);
        this.update_status = JSON.parse(data['_body']).status;
        this.update_count = JSON.parse(data['_body']).count;
        this.update_description = JSON.parse(data['_body']).description;
        this.update_toc = JSON.parse(data['_body']).toc;
        this.coupon_id = JSON.parse(data['_body']).id;

      });


    this.list = false;
    this.edit = true;
    this.add = false;
    this.icon = this.helper.list_icon;
    this.icon_action = 'listClick';
  }

  startEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.enddate = event.value;
    let d1 = new Date(Date.parse(this.enddate));
    this.enddate = d1.getFullYear() + '-' + (d1.getMonth() + 1) + '-' + d1.getDate();
  }

  refresh(val = false, msg = '') {
    this.snackbar.open(msg, null,
      {
        duration: 5000,
        extraClasses: 'success-snackbar',
        verticalPosition: 'top'
      });
    this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(() =>
      this.router.navigate(['coupons']));
  }

  add_form(addForm: NgForm) {
    let d1 = new Date(Date.parse(this.expiry_date));
    let date = d1.getFullYear() + '-' + (d1.getMonth() + 1) + '-' + d1.getDate();

    let body = new FormData();
    body.append('title', addForm.value.title);
    body.append('coupon_code', addForm.value.coupon_code);
    body.append('expiry_date', date);
    body.append('percentage', addForm.value.percentage);
    body.append('count', addForm.value.count);
    body.append('status', addForm.value.status);
    body.append('description', addForm.value.description);
    body.append('toc', addForm.value.toc);
    //body.append('userid', this.user);

    this.http.post(this.helper.base_url + 'http/add/coupon', body, {headers: this.headers})
      .subscribe((res) => {
          let body = JSON.parse(res['_body']);

          if (body.error == 1) {
            this.snackbar.open(body.message, null, {
              duration: 5000,
              extraClasses: 'error-snackbar',
              verticalPosition: 'top'
            });

          } else {
            this.refresh(false, body.message);
          }
          //this.refresh(false,'Coupon added successfully') ;
        }, //For Success Response
        err => {
          console.error(err);
        } //For Error Response);
      );
  }

  update_form(addForm: NgForm) {
    let d1 = new Date(Date.parse(this.update_expiry_date));
    let date = d1.getFullYear() + '-' + (d1.getMonth() + 1) + '-' + d1.getDate();

    let body = new FormData();
    body.append('expiry_date', date);
    body.append('count', this.update_count);
    body.append('status', this.update_status);
    body.append('description', this.update_description);
    body.append('toc', this.update_toc);
    body.append('id', this.coupon_id);

    this.http.post(this.helper.base_url + 'http/update/coupon', body, {headers: this.headers})
      .subscribe((data) => {
          let body = JSON.parse(data['_body']);

          if (body.success == 1) {
            this.refresh(false, body.message);
          } else {
            this.snackbar.open(body.message, null, {
              duration: 5000,
              extraClasses: 'error-snackbar',
              verticalPosition: 'top'
            });
          }
        }, //For Success Response
        err => {
          console.error(err);
        } //For Error Response);
      );
  }

  deleteClick(id) {
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      //this.snackbar.open('Are you sure!', 'Delete', {
      duration: 3000,
      extraClasses: ['warning-snackbar'],
    });
    snackBarRef.onAction().subscribe(() => {
      this.http.get(this.helper.base_url + 'http/delete/coupon/' + id, {headers: this.headers})
        .subscribe(data => {
          let body = JSON.parse(data['_body']);

          if (body.success == 1) {
            this.refresh(false, body.message);
          } else {
            this.snackbar.open(body.message, null, {
              duration: 5000,
              extraClasses: 'error-snackbar',
              verticalPosition: 'top'
            });
          }

          // this.refresh(false,'Coupon Removed successfully') ;7.5
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/coupons/coupons.component.ts